import React from "react";
import { Link } from "react-router-dom";

import Seo from "../seo/Seo";
import {
  organizationSchema,
  webPageSchema,
  breadcrumbSchema,
} from "../seo/schema";
import PageHeader from "../components/PageHeader";
import Breadcrumbs from "../components/Breadcrumbs";
import { useNowIST } from "../lib/useResults";

const PATH = "/disclaimer";

const Disclaimer = () => {
  const nowIST = useNowIST();

  const title = "Disclaimer | Bagad Satta Company";
  const description =
    "Bagad Satta Company publishes results for informational purposes only. We are not a gambling operator and are not affiliated with any satta matka company. Read the full disclaimer.";

  const trail = [
    { name: "Home", path: "/" },
    { name: "Disclaimer", path: PATH },
  ];

  return (
    <>
      <Seo
        path={PATH}
        title={title}
        description={description}
        schema={[
          organizationSchema(),
          webPageSchema({ path: PATH, title, description }),
          breadcrumbSchema(trail),
        ]}
      />

      <div className="page-banner">
        <div className="container page-padding">
          <Breadcrumbs trail={trail} />
          <PageHeader h1="Disclaimer" nowIST={nowIST} />

          <section className="card text-content">
            <h2>Informational Use Only</h2>
            <p>
              Everything published on this website is provided for informational
              and entertainment purposes only. Nothing here is advice, an
              invitation, or an encouragement to gamble.
            </p>

            <h2>No Affiliation</h2>
            <p>
              Bagad Satta Company is not a satta matka company, bookmaker, agent
              or gambling operator, and we are not affiliated with, endorsed by,
              or acting on behalf of any such organisation.
            </p>

            <h2>Legality</h2>
            <p>
              Satta, matka and most forms of gambling are illegal in many Indian
              states and in many other countries, and the law differs from state
              to state. It is your responsibility to know and follow the law
              where you live. We do not encourage or promote gambling in any
              form, and this site is not intended for anyone under 18.
            </p>

            <h2>Accuracy</h2>
            <p>
              We take care to publish numbers correctly and to mark undeclared
              results as XX rather than guessing. Even so, we cannot guarantee
              that every figure is free of error or delay, and we accept no
              liability for any loss arising from reliance on anything published
              here. If you find a mistake, please{" "}
              <Link to="/contact-us">tell us</Link> and we will correct it.
            </p>

            <h2>External Links</h2>
            <p>
              Some pages link to an external Android application. We do not
              control external websites or applications and are not responsible
              for their content, their terms or their handling of your data.
            </p>

            <h2>Financial Risk</h2>
            <p>
              Any money placed on games of chance can be lost in full. Never
              stake money you cannot afford to lose. If gambling is causing you
              or someone you know harm, please seek professional help.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default Disclaimer;
